import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimeout } from 'usehooks-ts';
import Toast from '@ingka/toast';
import { ToastMessage } from '@pcmp/react-providers';
import { getToastDuration } from '@/lib/utils/toast';

export const ToastItem: FC<{
  item: ToastMessage;
  onDismiss: (item: ToastMessage) => void;
}> = ({ item, onDismiss }) => {
  const { t } = useTranslation();
  const [toastVisible, setToastVisible] = useState(true);
  const { message, timeout } = item;
  const handleDismiss = async () => {
    setToastVisible(false);
    await new Promise((res) => setTimeout(res, 1000));
    onDismiss(item);
  };

  useTimeout(handleDismiss, timeout || getToastDuration(message));

  return (
    <Toast
      style={{ zIndex: 9999 }}
      text={message}
      data-testid="toast-item"
      isOpen={toastVisible}
      onCloseRequest={handleDismiss}
      ariaLabelCloseBtn={t('aria.dismissNotification')}
    />
  );
};
